import { FC } from 'react';
import { Box, Label, Radio, Text } from 'roo-ui/components';
import { CreditVoucherDisclaimer } from 'components/Disclaimers';
import { useCancellationQuote } from 'pages/CancellationQuotePage/CancellationQuoteProvider';
import * as track from 'lib/gaTracking/cancelBookingPageEvents';
import { RefundType } from 'lib/graphql';
import { Cancellation } from 'types';

interface RefundOptionsProps {
  onChange: (value: RefundType) => any;
  value: RefundType;
  activeValue: RefundType;
}

const RefundOptionField: FC<RefundOptionsProps> = ({ children, onChange, value, activeValue }) => (
  <Label textStyle="text">
    <Radio name="refundMethod" checked={activeValue === value} value={value} onChange={() => onChange(value)} />
    {children}
  </Label>
);

const RefundOptionsForm: FC = () => {
  const { setRefundType, refundType, cancellation } = useCancellationQuote();

  const handleChange = (value: RefundType) => {
    setRefundType(value);
    track.refundOptionsToggle(value);
  };

  return (
    <Box is="form">
      <RefundOptionField value="NORMAL" activeValue={refundType} onChange={handleChange} data-testid="refund-to-creditcard">
        {getRefundLabel(cancellation)}
      </RefundOptionField>

      <RefundOptionField value="CREDIT_NOTE" activeValue={refundType} onChange={handleChange} data-testid="refund-to-voucher">
        <Text>Credit Voucher</Text>
        <CreditVoucherDisclaimer.Link />
      </RefundOptionField>
    </Box>
  );
};

function getRefundLabel(cancellation?: Cancellation) {
  let points = false as boolean;
  let cash = false as boolean;

  cancellation?.refund?.totals.forEach(({ amount, currency }) => {
    if (parseFloat(amount) > 0) {
      if (currency === 'AUD') cash = true;
      if (currency === 'PTS') points = true;
    }
  });

  switch (true) {
    case points && cash:
      return 'Refund my credit card and Qantas Frequent Flyer account';
    case points:
      return 'Refund my Qantas Frequent Flyer account';
    default:
      return 'Refund my credit card';
  }
}

export default RefundOptionsForm;
